/* eslint-disable react/no-array-index-key */
import React, { lazy, Suspense, Fragment } from 'react';
import { Switch, Redirect, Route } from 'react-router-dom';
import AdminLayout from 'src/layouts/AdminLayout';
import StudioLayout from 'src/layouts/StudioLayout';
import LiveChatLayout from 'src/layouts/LiveChatLayout';
import DocsLayout from 'src/layouts/DocsLayout';
import LoadingScreen from 'src/components/LoadingScreen';
import AuthGuard from 'src/components/AuthGuard';
import GuestGuard from 'src/components/GuestGuard';
import ChannelWebGuard from 'src/components/channelWebGuard';
const routesConfig = [
  {
    exact: true,
    path: '/',
    component: () => <Redirect to='/login' />
  },
  {
    exact: true,
    path: '/404',
    component: lazy(() => import('src/views/pages/Error404View'))
  },
  {
    exact: true,
    guard: GuestGuard,
    path: '/login',
    component: lazy(() => import('src/views/auth/LoginView'))
  },
  {
    exact: true,
    path: '/login-unprotected',
    component: lazy(() => import('src/views/auth/LoginView'))
  },
  {
    exact: true,
    path: '/change-password',
    component: lazy(() => import('src/views/auth/ChangePasswordView'))
  },
  {
    exact: true,
    path: '/forgot-password',
    component: lazy(() => import('src/views/auth/ForgotPasswordView'))
  },
  {
    exact: true,
    path: '/register-unprotected',
    component: lazy(() => import('src/views/auth/RegisterView'))
  },
  {
    exact: true,
    guard: ChannelWebGuard,
    path: ['/channelWeb/:botId', '/channelWeb/:botId/:userId'],
    component: lazy(() => import('src/views/channelWeb'))
  },
  /*live chat*/

  {
    exact: true,
    guard: AuthGuard,
    layout: LiveChatLayout,
    path: ['/livechat/:botId/new', '/livechat/:botId/:threadKey'],
    component: lazy(() => import('src/views/admin/Livechat/ChatView'))
  },

  {
    path: '/admin/:workspaceId',
    guard: AuthGuard,
    layout: AdminLayout,
    routes: [
      /*Bots*/
      {
        exact: true,
        path: '/admin/:workspaceId',
        component: () => <Redirect to='/login' />
      },
      /*Workspaces*/
      {
        exact: true,
        path: '/admin/:workspaceId/list',
        component: lazy(() => import('src/views/admin/WorkspacesView'))
      },
      {
        exact: true,
        path: '/admin/:workspaceId',
        component: () => <Redirect to='/login' />
      },
      {
        exact: true,
        path: '/admin/:workspaceId/bots',
        component: lazy(() => import('src/views/admin/BotsListView'))
      },
      {
        exact: true,
        path: '/admin/:workspaceId/bots/:botId',
        component: lazy(() => import('src/views/admin/BotsCreateView'))
      },
      /*Staff*/
      {
        exact: true,
        path: '/admin/:workspaceId/staff/:staffId',
        component: lazy(() => import('src/views/admin/StaffCreateView'))
      },
      {
        exact: true,
        path: '/admin/:workspaceId/staff',
        component: lazy(() => import('src/views/admin/StaffListView'))
      },
      /*Profile*/
      {
        exact: true,
        path: '/admin/:workspaceId/profile',
        component: lazy(() => import('src/views/pages/AccountView'))
      },
      /*Roles*/
      {
        exact: true,
        path: '/admin/:workspaceId/roles',
        component: lazy(() => import('src/views/admin/RolesView'))
      },

      /*Add Number*/
      {
        exact: true,
        path: '/admin/:workspaceId/add-number/:partnerId',
        component: lazy(() => import('src/views/admin/AddNumberView'))
      }
    ]
  },
  {
    path: '/studio/:botId',
    guard: AuthGuard,
    layout: StudioLayout,
    routes: [
      {
        exact: true,
        path: '/studio/:botId/home',
        component: lazy(() => import('src/views/home/OverviewView'))
      },

      /*Analytics*/
      {
        exact: true,
        path: '/studio/:botId/analytics',
        component: lazy(() => import('src/views/analytics/analyticsView'))
      },
      {
        exact: true,
        path: '/studio/:botId/analytics/allTickets',
        component: lazy(() =>
          import('src/views/analytics/analyticsView/TicketsListView')
        )
      },

      /*Support*/
      {
        exact: true,
        path: [
          '/studio/:botId/support/new',
          '/studio/:botId/support/:threadKey/:handoffKey'
        ],
        component: lazy(() => import('src/views/support/ChatView'))
      },

      /*Profile*/
      {
        exact: true,
        path: '/studio/:botId/profile',
        component: lazy(() => import('src/views/pages/AccountView'))
      },

      /*Leads*/
      {
        exact: true,
        path: '/studio/:botId/leads',
        component: lazy(() => import('src/views/leads/CustomerListView'))
      },
      {
        exact: true,
        path: '/studio/:botId/leadsDetails/:leadId',
        component: lazy(() => import('src/views/leads/CustomerDetailsView'))
      },

      // {
      //   exact: true,
      //   path: '/studio/:botId/leadsEdit/:leadId',
      //   component: lazy(() => import('src/views/leads/CustomerEditView'))
      // },

      /*Settings*/

      {
        exact: true,
        path: '/studio/:botId/settings',
        component: lazy(() => import('src/views/settings/View'))
      },

      /*Actions*/

      {
        exact: true,
        path: [
          '/studio/:botId/actions/new',
          '/studio/:botId/actions/:actionId'
        ],
        component: lazy(() => import('src/views/actions/actionsView'))
      },

      /*LLM Playground*/
      {
        exact: true,
        path: '/studio/:botId/llm-playground',
        component: lazy(() => import('src/views/llmPlayground'))
      },

      {
        path: '/**',
        component: lazy(() => import('src/views/home/OverviewView'))
      }
    ]
  },

  {
    path: '/studio/:colaId',
    guard: AuthGuard,
    layout: StudioLayout,
    routes: [
      {
        exact: true,
        path: '/studio/:colaId/home',
        component: lazy(() => import('src/views/home/OverviewView'))
      }
    ]
  },
  {
    path: '/docs',
    layout: DocsLayout,
    routes: [
      {
        exact: true,
        path: '/docs',
        component: () => <Redirect to='/docs/welcome' />
      },
      {
        exact: true,
        path: '/docs/welcome',
        component: lazy(() => import('src/views/docs/en/WelcomeView'))
      },
      {
        exact: true,
        path: '/docs/getting-started',
        component: lazy(() => import('src/views/docs/en/GettingStartedView'))
      },
      {
        exact: true,
        path: '/docs/channels-restrictions',
        component: lazy(() => import('src/views/docs/en/Restrictions'))
      },
      {
        exact: true,
        path: '/docs/admin',
        component: lazy(() => import('src/views/docs/en/AdminView'))
      },
      {
        exact: true,
        path: '/docs/studio',
        component: lazy(() => import('src/views/docs/en/StudioView'))
      },
      {
        exact: true,
        path: '/docs/api-calls',
        component: lazy(() => import('src/views/docs/en/ApiCallsView'))
      },
      {
        exact: true,
        path: '/docs/human-help',
        component: lazy(() => import('src/views/docs/en/HumanhelpView'))
      },
      {
        exact: true,
        path: '/docs/nlu-config',
        component: lazy(() => import('src/views/docs/en/NluView'))
      },
      {
        exact: true,
        path: '/docs/channels-config',
        component: lazy(() => import('src/views/docs/en/ChannelsView'))
      },
      {
        exact: true,
        path: '/docs/actions',
        component: lazy(() => import('src/views/docs/en/ActionsView'))
      },
      {
        exact: true,
        path: '/docs/authentication',
        component: lazy(() => import('src/views/docs/en/AuthenticationView'))
      },

      {
        exact: true,
        path: '/docs/settings',
        component: lazy(() => import('src/views/docs/en/SettingsView'))
      },

      {
        exact: true,
        path: '/docs/changelog',
        component: lazy(() => import('src/views/docs/en/ChangelogView'))
      },

      {
        exact: true,
        path: '/docs/messages',
        component: lazy(() => import('src/views/docs/en/MessagesView'))
      },
      {
        component: () => <Redirect to='/404' />
      }
    ]
  },
  {
    path: '*',
    routes: [
      {
        exact: true,
        path: '/home',
        component: () => <Redirect to='/' />
      },
      {
        component: () => <Redirect to='/404' />
      }
    ]
  }
];

const renderRoutes = routes =>
  routes ? (
    <Suspense fallback={<LoadingScreen />}>
      <Switch>
        {routes.map((route, i) => {
          const Guard = route.guard || Fragment;
          const Layout = route.layout || Fragment;
          const Component = route.component;

          return (
            <Route
              key={i}
              path={route.path}
              exact={route.exact}
              render={props => (
                <Guard>
                  <Layout>
                    {route.routes ? (
                      renderRoutes(route.routes)
                    ) : (
                      <Component {...props} />
                    )}
                  </Layout>
                </Guard>
              )}
            />
          );
        })}
      </Switch>
    </Suspense>
  ) : null;

function Routes() {
  return renderRoutes(routesConfig);
}

export default Routes;
